import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';
import { ChildrenParams } from '../../models/Discussions/Children';

export const GET_CHILDREN_REQUEST = 'GET_CHILDREN_REQUEST';
export const GET_CHILDREN_RESPONSE = 'GET_CHILDREN_RESPONSE';
export const GET_CHILDREN_ERROR = 'GET_CHILDREN_ERROR';

export const GET_CHILD_REQUEST = 'GET_CHILD_REQUEST';
export const GET_CHILD_RESPONSE = 'GET_CHILD_RESPONSE';
export const GET_CHILD_ERROR = 'GET_CHILD_ERROR';

export const CREATE_CHILDREN_REQUEST = 'CREATE_CHILDREN_REQUEST';
export const CREATE_CHILDREN_RESPONSE = 'CREATE_CHILDREN_RESPONSE';
export const CREATE_CHILDREN_ERROR = 'CREATE_CHILDREN_ERROR';

export const EDIT_CHILDREN_REQUEST = 'EDIT_CHILDREN_REQUEST';
export const EDIT_CHILDREN_RESPONSE = 'EDIT_CHILDREN_RESPONSE';
export const EDIT_CHILDREN_ERROR = 'EDIT_CHILDREN_ERROR';

export const DELETE_CHILDREN_REQUEST = 'DELETE_CHILDREN_REQUEST';
export const DELETE_CHILDREN_RESPONSE = 'DELETE_CHILDREN_RESPONSE';
export const DELETE_CHILDREN_ERROR = 'DELETE_CHILDREN_ERROR';

const DISCUSSIONS_HOST = process.env.REACT_APP_DISCUSSIONS_HOST;
const DISCUSSIONS_KEY = process.env.REACT_APP_DISCUSSIONS_KEY;

export const getChildrenAction = (clientId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CHILDREN_REQUEST,
    });

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/children?client_id=${clientId}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .json();

        dispatch({
            type: GET_CHILDREN_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_CHILDREN_ERROR,
            error,
        });
    }
};

export const getChildAction = (id: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CHILD_REQUEST,
    });

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/children/${id}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .json();

        dispatch({
            type: GET_CHILD_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_CHILD_ERROR,
            error,
        });
    }
};

export const createChildrenAction = (clientId: string, childrenParams: ChildrenParams) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CREATE_CHILDREN_REQUEST,
    });
    const body = {
        client_id: clientId,
        name: childrenParams.name,
        birthday: childrenParams.birthday,
        diseases: childrenParams.diseases,
        gender: childrenParams.gender
    };

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/children`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .post(body)
            .json();

        dispatch({
            type: CREATE_CHILDREN_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: CREATE_CHILDREN_ERROR,
            error,
        });
    }
};

export const editChildrenAction = (clientId: string, id: number, childrenParams: ChildrenParams) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: EDIT_CHILDREN_REQUEST,
    });
    const body = {
        client_id: clientId,
        name: childrenParams.name,
        birthday: childrenParams.birthday,
        diseases: childrenParams.diseases,
        gender: childrenParams.gender
    };

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/children/${id}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .put(body)
            .json();

        dispatch({
            type: EDIT_CHILDREN_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: EDIT_CHILDREN_ERROR,
            error,
        });
    }
};

export const deleteChildrenAction = (id: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELETE_CHILDREN_REQUEST
    });

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/children/${id}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .delete()
            .json();

        dispatch({
            type: DELETE_CHILDREN_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: DELETE_CHILDREN_ERROR,
            error,
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Discussions/children.ts